<template>
  <div class="footer-section">
    <RouterLink :to="{ name: 'Legal' }" class="item">{{ $t('legalInformation') }}</RouterLink>
    <span class="divider">●</span>
    <RouterLink :to="{ name: 'Confidentiality' }" class="item">{{ $t('privacyStatement') }}</RouterLink>
    <span class="divider">●</span>
    <RouterLink :to="{ name: 'Cookies' }" class="item">{{ $t('cookies') }}</RouterLink>
  </div>
</template>

<script>
export default {
  name: 'ZipzapFooter',

  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
@use '@/styles/colors.scss';

.footer-section {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 32px;

  .divider {
    margin: 0 8px;
  }

  .item {
    transition: 0.4s ease-in-out;
    cursor: pointer;

    &:hover {
      color: colors.$main-color;
      text-decoration: underline;
    }
  }
}
</style>
